export default () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9081_27996)">
      <g clipPath="url(#clip1_9081_27996)">
        <rect width="16" height="12" transform="translate(0 2)" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10H16V14H0V10Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6H16V10H0V6Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2H16V6H0V2Z"
          fill="#272727"
        />
      </g>
    </g>
    <rect
      x="0.5"
      y="2.5"
      width="15"
      height="11"
      rx="0.5"
      stroke="black"
      strokeOpacity="0.1"
      style={{ mixBlendMode: 'multiply' }}
    />
    <defs>
      <clipPath id="clip0_9081_27996">
        <rect y="2" width="16" height="12" rx="1" fill="white" />
      </clipPath>
      <clipPath id="clip1_9081_27996">
        <rect width="16" height="12" fill="white" transform="translate(0 2)" />
      </clipPath>
    </defs>
  </svg>
);
